<template>
  <template v-if="productModifierGroup">
    <div class="flex w-full justify-between p-2">
      <div>
        <div class="flex items-center justify-start">
          <span
            class="text-background-fg/87 text-lg font-medium"
          >
            {{ productModifierGroup.label }}
          </span>
          <template v-if="productModifierGroup.isShared">
            <span
              class="border-1 border-primary text-primary ml-2 rounded-full px-1 py-px text-xs"
            >
              shared
            </span>
          </template>
        </div>
        <div class="space-x-2 text-left">
          <template
            v-for="option in productModifierGroup.options"
            :key="option.id"
          >
            <span
              class="text-background-fg/70 text-xs font-medium"
            >
              - {{ option.label }}
            </span>
          </template>
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <div> broken </div>
  </template>
</template>

<script setup lang="ts">
const props = defineProps<{
  productModifierGroupId: string
}>()

const emit = defineEmits<{
  (event: "edit", params: string): void
}>()
const { getById } = useProductModifierGroups()

const productModifierGroup = getById(
  toRef(props, "productModifierGroupId")
)
</script>
